export const translations = {
  en: {
    brand: "Richcube Wealth",
    brand_tagline: "Property Marketplace",
    nav: {
      home: "Home",
      properties: "Properties",
      assured_return: "Assured Return",
      exclusive: "Exclusive",
      sell: "Sell / List",
      admin: "Admin",
      login: "Admin Login",
      logout: "Logout",
      dashboard: "Dashboard",
    },
    cities: { all: "All Cities", indore: "Indore", goa: "Goa" },
    hero: {
      eyebrow: "Private wealth. Tier 2/3 real estate.",
      title: "Own exclusive homes in Indore & Goa",
      subtitle:
        "Curated listings with Richcube Assured Returns, backed by our wealth-management rigour.",
      cta: "Browse properties",
    },
    search: {
      buy: "Buy",
      rent: "Rent",
      city: "City",
      type: "Property type",
      price_range: "Price range",
      search: "Search properties",
      any: "Any",
    },
    types: {
      all: "All types",
      Residential: "Residential",
      Commercial: "Commercial",
      Plot: "Plot",
      Airbnb: "Airbnb",
    },
    badges: {
      exclusive: "Richcube Exclusive",
      assured: "Assured Return",
      featured: "Featured",
    },
    rental: {
      label: "Assured Rental",
      per_month: "/mo",
      per_month_long: "/month",
      section_eyebrow: "Key Investment Highlight",
      section_title: "Assured Rental Returns",
      section_sub: "Monthly assured rental income per unit type.",
      on_request: "Price on Request",
      banner_title: "Earn Assured Rental Returns",
      banner_from: "Starting from",
      banner_cta: "View Featured Listings",
      disclaimer: "*Assured rental as per developer terms. Subject to agreement.",
    },
    sections: {
      featured: "Richcube Featured Listings",
      featured_sub: "Hand-picked homes with assured returns and gold-standard due diligence.",
      all_listings: "All Properties",
      all_sub: "Browse every live listing across Indore and Goa.",
      no_results: "No properties match your filters yet.",
    },
    card: {
      bhk: "BHK",
      sqft: "sqft",
      enquire: "Enquire Now",
      view: "View details",
      whatsapp: "WhatsApp",
    },
    detail: {
      overview: "Overview",
      specs: "Specifications",
      amenities: "Amenities",
      assured_block: "Richcube Assured Return",
      assured_desc:
        "Professionally managed income. Richcube deposits the assured rental yield into your account every month.",
      enquire_now: "Enquire Now",
      type: "Type",
      locality: "Locality",
      area: "Super built-up",
      bedrooms: "Bedrooms",
      furnishing: "Furnishing",
      facing: "Facing",
      ownership: "Ownership",
      listed_on: "Listed on",
      back: "Back to listings",
    },
    enquiry: {
      title: "Speak to a Richcube advisor",
      subtitle: "Share your details — we respond on WhatsApp and email within one business hour.",
      name: "Full name",
      phone: "Phone number",
      city: "City of interest",
      message: "Message (optional)",
      submit: "Submit enquiry",
      whatsapp_cta: "Chat on WhatsApp",
      success: "Thanks! Opening WhatsApp with your enquiry.",
    },
    footer: {
      about: "About Richcube",
      about_text:
        "Richcube Wealth Management curates premium real-estate opportunities in Tier 2/3 India. Every listing is screened by our wealth team.",
      quick: "Quick links",
      contact: "Contact",
      rights: "© 2026 Richcube Wealth Management. All rights reserved.",
      main_site: "richcube.in",
    },
    admin: {
      login_title: "Admin sign in",
      login_sub: "Manage property listings and enquiries.",
      email: "Email",
      password: "Password",
      sign_in: "Sign in",
      dashboard: "Admin dashboard",
      listings: "Listings",
      enquiries: "Enquiries",
      add: "Add property",
      edit: "Edit",
      delete: "Delete",
      save: "Save property",
      cancel: "Cancel",
      upload: "Upload images",
      exclusive: "Mark as Richcube Exclusive",
      featured: "Show on homepage (Featured)",
      assured: "Assured return",
      assured_pct: "Assured return %",
      title_en: "Title (English)",
      title_hi: "Title (Hindi)",
      description_en: "Description (English)",
      description_hi: "Description (Hindi)",
      locality: "Locality",
      price: "Price (₹)",
      price_display: "Price label (e.g. 2.4 Cr)",
      bhk: "BHK",
      sqft: "Sqft",
      furnishing: "Furnishing",
      facing: "Facing",
      ownership: "Ownership",
      amenities: "Amenities (comma separated)",
      image_urls: "Image URLs (comma separated)",
      confirm_delete: "Delete this property?",
      no_enquiries: "No enquiries yet.",
    },
  },
  hi: {
    brand: "रिचक्यूब वेल्थ",
    brand_tagline: "प्रॉपर्टी मार्केटप्लेस",
    nav: {
      home: "होम",
      properties: "प्रॉपर्टी",
      assured_return: "निश्चित रिटर्न",
      exclusive: "एक्सक्लूसिव",
      sell: "बेचें / लिस्ट करें",
      admin: "एडमिन",
      login: "एडमिन लॉगिन",
      logout: "लॉगआउट",
      dashboard: "डैशबोर्ड",
    },
    cities: { all: "सभी शहर", indore: "इंदौर", goa: "गोवा" },
    hero: {
      eyebrow: "निजी संपत्ति। टियर 2/3 रियल एस्टेट।",
      title: "इंदौर और गोवा में विशिष्ट घर खरीदें",
      subtitle:
        "रिचक्यूब की निश्चित रिटर्न वाली चुनिंदा लिस्टिंग्स, वेल्थ मैनेजमेंट की कठोरता के साथ।",
      cta: "प्रॉपर्टी देखें",
    },
    search: {
      buy: "खरीदें",
      rent: "किराया",
      city: "शहर",
      type: "संपत्ति प्रकार",
      price_range: "मूल्य सीमा",
      search: "प्रॉपर्टी खोजें",
      any: "कोई भी",
    },
    types: {
      all: "सभी प्रकार",
      Residential: "आवासीय",
      Commercial: "वाणिज्यिक",
      Plot: "प्लॉट",
      Airbnb: "एयरबीएनबी",
    },
    badges: {
      exclusive: "रिचक्यूब एक्सक्लूसिव",
      assured: "निश्चित रिटर्न",
      featured: "विशेष",
    },
    rental: {
      label: "निश्चित किराया",
      per_month: "/माह",
      per_month_long: "/माह",
      section_eyebrow: "मुख्य निवेश विशेषता",
      section_title: "निश्चित किराया रिटर्न",
      section_sub: "हर यूनिट प्रकार पर मासिक निश्चित किराया आय।",
      on_request: "अनुरोध पर मूल्य",
      banner_title: "निश्चित किराया रिटर्न कमाएँ",
      banner_from: "शुरुआत",
      banner_cta: "विशेष लिस्टिंग देखें",
      disclaimer: "*निश्चित किराया डेवलपर की शर्तों के अनुसार। अनुबंध के अधीन।",
    },
    sections: {
      featured: "रिचक्यूब विशेष लिस्टिंग्स",
      featured_sub: "निश्चित रिटर्न और गोल्ड-स्टैंडर्ड ड्यू डिलिजेंस वाले चुनिंदा घर।",
      all_listings: "सभी प्रॉपर्टी",
      all_sub: "इंदौर और गोवा की सभी लाइव लिस्टिंग्स देखें।",
      no_results: "आपके फ़िल्टर से कोई प्रॉपर्टी मेल नहीं खाती।",
    },
    card: {
      bhk: "BHK",
      sqft: "वर्ग फुट",
      enquire: "पूछताछ करें",
      view: "विवरण देखें",
      whatsapp: "व्हाट्सऐप",
    },
    detail: {
      overview: "अवलोकन",
      specs: "विशिष्टताएँ",
      amenities: "सुविधाएँ",
      assured_block: "रिचक्यूब निश्चित रिटर्न",
      assured_desc:
        "पेशेवर प्रबंधन वाली आय। रिचक्यूब आपके खाते में हर महीने निश्चित रिटर्न जमा करता है।",
      enquire_now: "पूछताछ करें",
      type: "प्रकार",
      locality: "क्षेत्र",
      area: "सुपर बिल्ट-अप",
      bedrooms: "बेडरूम",
      furnishing: "फर्निशिंग",
      facing: "दिशा",
      ownership: "स्वामित्व",
      listed_on: "सूचीबद्ध",
      back: "लिस्टिंग्स पर लौटें",
    },
    enquiry: {
      title: "रिचक्यूब सलाहकार से बात करें",
      subtitle:
        "अपनी जानकारी साझा करें — हम एक घंटे में व्हाट्सऐप और ईमेल पर उत्तर देंगे।",
      name: "पूरा नाम",
      phone: "फ़ोन नंबर",
      city: "रुचि का शहर",
      message: "संदेश (वैकल्पिक)",
      submit: "पूछताछ भेजें",
      whatsapp_cta: "व्हाट्सऐप पर चैट करें",
      success: "धन्यवाद! व्हाट्सऐप खोला जा रहा है।",
    },
    footer: {
      about: "रिचक्यूब के बारे में",
      about_text:
        "रिचक्यूब वेल्थ मैनेजमेंट टियर 2/3 भारत में प्रीमियम रियल एस्टेट अवसर प्रस्तुत करता है।",
      quick: "त्वरित लिंक",
      contact: "संपर्क",
      rights: "© 2026 रिचक्यूब वेल्थ मैनेजमेंट। सर्वाधिकार सुरक्षित।",
      main_site: "richcube.in",
    },
    admin: {
      login_title: "एडमिन साइन इन",
      login_sub: "लिस्टिंग्स और पूछताछ प्रबंधित करें।",
      email: "ईमेल",
      password: "पासवर्ड",
      sign_in: "साइन इन",
      dashboard: "एडमिन डैशबोर्ड",
      listings: "लिस्टिंग्स",
      enquiries: "पूछताछ",
      add: "प्रॉपर्टी जोड़ें",
      edit: "संपादित करें",
      delete: "हटाएँ",
      save: "सहेजें",
      cancel: "रद्द करें",
      upload: "छवियाँ अपलोड करें",
      exclusive: "रिचक्यूब एक्सक्लूसिव के रूप में चिह्नित करें",
      featured: "होमपेज पर दिखाएँ",
      assured: "निश्चित रिटर्न",
      assured_pct: "निश्चित रिटर्न %",
      title_en: "शीर्षक (अंग्रेज़ी)",
      title_hi: "शीर्षक (हिंदी)",
      description_en: "विवरण (अंग्रेज़ी)",
      description_hi: "विवरण (हिंदी)",
      locality: "क्षेत्र",
      price: "मूल्य (₹)",
      price_display: "मूल्य लेबल",
      bhk: "BHK",
      sqft: "वर्ग फुट",
      furnishing: "फर्निशिंग",
      facing: "दिशा",
      ownership: "स्वामित्व",
      amenities: "सुविधाएँ (अल्पविराम से अलग)",
      image_urls: "छवि URL (अल्पविराम से अलग)",
      confirm_delete: "इस प्रॉपर्टी को हटाएँ?",
      no_enquiries: "अभी तक कोई पूछताछ नहीं।",
    },
  },
};
